import SectionHeading from "@/components/SectionHeading";
import { FadeUp } from "@/components/Reveal";
import { PARTNERS } from "@/data/content";

const Partners = ({ dark = false }) => (
  <section data-testid="partners-section" className={`py-28 lg:py-32 ${dark ? "bg-forest-900" : ""}`}>
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <SectionHeading
        align="center"
        eyebrow="Research Collaborations"
        titleLines={["Backed by India's finest", "agricultural institutions."]}
        description="We collaborate with a number of national institutions to create products that meet the changing needs of farmers."
      />
      <div className="grid grid-cols-2 gap-5 sm:grid-cols-3 lg:grid-cols-4" data-testid="partners-grid">
        {PARTNERS.map((p, i) => (
          <FadeUp key={p.name} delay={(i % 4) * 0.07} className="h-full">
            <div
              className="group flex h-full flex-col items-center justify-between border border-[#123C6B]/10 bg-white p-6 text-center transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_20px_50px_rgba(18,60,107,0.12)]"
              data-testid={`partner-card-${i}`}
            >
              <div className="flex h-24 w-full items-center justify-center">
                <img
                  src={p.logo}
                  alt={`${p.name} logo`}
                  loading="lazy"
                  className="max-h-20 w-auto object-contain transition-transform duration-300 group-hover:scale-105"
                />
              </div>
              <div className="mt-5">
                <p className="font-display text-base font-bold tracking-tight text-foreground">{p.name}</p>
                <p className="mt-1 text-[11px] leading-snug text-sage">{p.full}</p>
              </div>
            </div>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
);

export default Partners;
